/**
 * The teacher guides: which exist, in which order and group. The texts
 * are `content/<file>.md` (German, loaded by `content.ts` with the guide
 * page only); a missing file leaves its section out.
 */

export const GUIDE_GROUPS = [
  { id: 'start', title: 'Los geht’s' },
  { id: 'games', title: 'Spiele' },
  { id: 'questions', title: 'Fragen und Sets' },
] as const;

export interface GuideSection {
  /** Anchor on the page: `/anleitungen#<id>`. */
  id: string;
  title: string;
  /** One line under the title. */
  lead?: string;
  group: (typeof GUIDE_GROUPS)[number]['id'];
  /** The game this section explains (tile and "Spiel starten"). */
  gameId?: string;
  file: string;
}

export const SECTIONS: GuideSection[] = [
  { id: 'erste-schritte', title: 'Erste Schritte', group: 'start', file: 'erste-schritte' },
  { id: 'blitzquiz', title: 'Blitzquiz', group: 'games', gameId: 'quiz', file: 'quiz' },
  {
    id: 'eins-zwei-drei',
    title: '1, 2 oder 3',
    group: 'games',
    gameId: 'eins-zwei-drei',
    file: 'eins-zwei-drei',
  },
  { id: 'buzzer', title: 'Buzzer', group: 'games', gameId: 'buzzer', file: 'buzzer' },
  { id: 'jeopardy', title: 'Jeopardy', group: 'games', gameId: 'jeopardy', file: 'jeopardy' },
  {
    id: 'teamraetsel',
    title: 'Teamrätsel',
    group: 'games',
    gameId: 'teamraetsel',
    file: 'teamraetsel',
  },
  {
    id: 'jaeger',
    title: 'Klasse gegen den Jäger',
    group: 'games',
    gameId: 'jaeger',
    file: 'jaeger',
  },
  {
    id: 'bilderraetsel',
    title: 'Bilderrätsel',
    group: 'games',
    gameId: 'bilderraetsel',
    file: 'bilderraetsel',
  },
  {
    id: 'kreuzwortraetsel',
    title: 'Kreuzworträtsel',
    group: 'games',
    gameId: 'kreuzwort',
    file: 'kreuzwort',
  },
  {
    id: 'fakt-oder-fake',
    title: 'Fakt oder Fake',
    group: 'games',
    gameId: 'faktfake',
    file: 'faktfake',
  },
  { id: 'erklaer-es', title: 'Erklär es', group: 'games', gameId: 'erklaeres', file: 'erklaeres' },
  { id: 'werwolf', title: 'Werwolf', group: 'games', gameId: 'werwolf', file: 'werwolf' },
  { id: 'sets', title: 'Fragensets und Editor', group: 'questions', file: 'sets' },
  {
    id: 'textformat-blitzquiz',
    title: 'Textformat: Blitzquiz',
    group: 'questions',
    file: 'quiz-textformat',
  },
  {
    id: 'textformat-jeopardy',
    title: 'Textformat: Jeopardy',
    group: 'questions',
    file: 'jeopardy-textformat',
  },
  {
    id: 'fragenbibliothek',
    title: 'Fragenbibliothek',
    group: 'questions',
    file: 'fragenbibliothek',
  },
  { id: 'quiz-generator', title: 'Quiz-Generator', group: 'questions', file: 'quiz-generator' },
  { id: 'medien', title: 'Bilder, Töne, Videos', group: 'questions', file: 'medien' },
];

/** The section that explains a game (format pages link to it). */
export function guideIdFor(gameId: string): string | null {
  return SECTIONS.find((s) => s.gameId === gameId)?.id ?? null;
}
